/*
 HotelTest

 Tresc regulaminu dla hotel-TEST
  
 historia: 
  PM 2021-12-08 - start
*/

import * as React from 'react';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Button, Theme, Typography } from '@material-ui/core';

class HotelTest extends React.Component<WithStyles<typeof styles>, any> {

    render() {
        const { classes } = this.props;
        if (document.title !== 'Warunki doładowania') {
            document.title = 'Warunki doładowania';
        }

        return (
            <React.Fragment>
                <Typography variant='h6' align="center"><b>WARUNKI DOŁADOWANIA</b></Typography><br />

                <ol type="1">
                    <li><Typography variant='body2' gutterBottom>Strona internetowa <a href="https://leskoski.pl" target="_blank" rel="noreferrer" className={classes.link}>
                        <Button
                            variant="text"
                            size="large"
                            className={`${classes.linkButton} ${classes.body2Button}`}
                        >
                            <b>https://leskoski.pl</b>
                        </Button>
                    </a> - zakładka <span style={{fontStyle: "italic"}}>Doładowania</span> przeznaczona jest do doładowania karnetów narciarskich w obiekcie Lesko Summer & Ski.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Właścicielem serwisu oraz prezentowanych na stronie treści jest firma <b>Lesko Summer & Ski Sp. z o. o.</b> Przedsiębiorstwo zarejestrowane w KRS pod numerem 0000588841, REGON 363107662, NIP 6881300543; adres poczty elektronicznej <a href={`mailto:${'weremien@leskoski.pl'}`} target='_blank' className={`${classes.email}`}><b>{'weremien@leskoski.pl'}</b></a>; numer rachunku bankowego mBank 30 1140 2004 0000 3002 8543 6873.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Doładowania karnetów można dokonywać <b>on-line</b> za pośrednictwem serwisu.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Warunkiem doładowania jest płatność on-line <b>100%</b> ceny w momencie doładowania.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Przed dokonaniem płatności posiadacz karnetu <b>zobowiązany</b> jest do zaakceptowania warunków doładowania.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Ze względu na charakter usługi doładowania, która jest wykonana w całości natychmiastowo po otrzymaniu zapłaty <b>nie ma</b> możliwości skorzystania z prawa do odstąpienia od umowy.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Operatorem płatności jest <b>mBank.</b></Typography></li>
                    <li><Typography variant='body2' gutterBottom>Możliwa jest płatność <b>off-line</b> za doładowania karnetu w kasach obiektu.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>W kasach obiektu akceptujemy płatności <b>gotówką i kartami</b> płatniczymi.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Wszelkie <b>reklamacje</b> powinny być zgłaszane mailowo na adres <a href="rezerwacja@leskoski.pl" target="_blank" rel="noreferrer" className={classes.link}>
                        {/* <Button
                            variant="text"
                            size="large"
                            className={`${classes.linkButton} ${classes.body2Button}`}
                        >
                            <b>rezerwacja@leskoski.pl</b>
                        </Button> */}
                        <a href={`mailto:${'rezerwacja@leskoski.pl'}`} target='_blank' className={`${classes.email}`}><b>{'rezerwacja@leskoski.pl'}</b></a>
                    </a>. Czas odpowiedzi na reklamację wynosi do 7 dni roboczych.</Typography></li>
                </ol>

                <br />
            </React.Fragment>
        );
    }
}

const styles = (theme: Theme) => ({
    noMarginTop: {
        marginTop: 0,
    },
    noMarginBottom: {
        marginBottom: 0,
    },
    listItem: {
        display: 'list-item',
        marginLeft: theme.spacing(5),
    },
    listNone: {
        listStyleType: 'none'
    },
    breakSpaces: {
        whiteSpace: 'break-spaces' as 'break-spaces'
    },
    linkButton: {
        color: '#3a87ad',
        "&:hover": {
            textDecoration: "underline"
        }
    },
    h6Button: {
        padding: 0,
        fontSize: theme.typography.h6.fontSize,
        lineHeight: theme.typography.h6.lineHeight,
        letterSpacing: theme.typography.h6.letterSpacing,
        textTransform: 'none' as 'none',
        minWidth: 0,
        "&:hover": {
            background: 'none'
        }
    },
    body2Button: {
        padding: 0,
        fontSize: theme.typography.body2.fontSize,
        lineHeight: '16px',
        letterSpacing: theme.typography.body2.letterSpacing,
        textTransform: 'none' as 'none',
        minWidth: 0,
        "&:hover": {
            background: 'none'
        }
    },
    link: {
        textDecoration: 'none',
        lineBreak: 'anywhere' as 'anywhere'
    },
    alignCenter: {
        display: 'block',
        textAlign: 'center' as 'center'
    },
    email: {
        //color: "inherit",
        color: '#3a87ad',
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline"
        }
    },
});

export default withStyles(styles)(HotelTest);
